export default "__VITE_ASSET__B0VyC8K6__"